export default "__VITE_ASSET__d146d378__"